<template>
    <div>
        <h1>Screening Portal &Uuml;bermittlung</h1>
        Hier werden Ihnen die, f&uuml;r die Screening Portal vorgemerkten Barcodes und deren
        Stati, angezeigt.<br/><br/>

       <div v-if="this.$store.getters.getSMSNo" class="info" style="max-width: 930px; padding: 10px; margin-bottom: 10px; background-color: #0078ff">
            <b>Positive Express Proben</b> werden Ihnen <b>per SMS an {{ this.$store.getters.getSMSNo }}</b> mitgeteilt.
        </div>
 
        <div class="info" :class="{ 'error': !this.$store.getters.getSPDaemonState.scSyncDaemonUp }" style="max-width: 930px; padding: 10px; margin-bottom: 10px;">
            <span v-if="this.$store.getters.getSPDaemonState.scSyncDaemonUp">
                <b>Status:</b> Die Software zur &Uuml;bertragung ans Screening Portal l&auml;uft.
            </span>
            <span v-else>
                <b>Information:</b> Es werden aktuell keine automatisierten Befundungen vorgenommen.
                Bitte befunden Sie manuell.
            </span>
        </div>


        <table border=1>
            <thead>
                <th width="150">Datum</th>
                <th width="150">Barcode</th>
                <th width="150">Geplanter Versand</th>
                <th width="180">Status</th>
                <th width="300">Aktionen</th>
            </thead>
            <tbody>
            <tr v-for="t in this.$store.getters.SPQueued">
                <td>&nbsp;{{t.jobCreated }}</td>
                <td>&nbsp;{{t.barcode }}</td>
                <td>
                    <span>{{t.sendDate }}</span>
                </td>

                <td :class="{ 'spcsuccess' : t.transfered == 1, 'sperror' : t.transfered == 9 }">&nbsp;
                    <span v-if="t.transfered == 1">erfolgreich</span>
                    <span v-if="t.transfered == 9">Fehler</span>
                    <span v-if="!t.transfered">wartet</span>
                </td>
                <td>
                    <div v-if="t.express">
                        <span style="padding: 0px; background-color: gold;min-width: 30px;"><i class="fas fa-star"></i> Express Test</span>
                    </div>
                    <div v-else>
                        <div v-if="!t.transfered == 1 || t.transfered == 9">
                            &nbsp;<a style="cursor: pointer;" v-on:click="CancelTransmit(t)">&Uuml;bermittlung abbrechen</a>
                            <span v-if="t.delayHour !== 0"> | <a style="cursor: pointer;" v-on:click="SendNow(t)">Jetzt senden</a></span>
                        </div>
                        <div v-else>keine Aktionen m&ouml;glich</div>
                    </div>
                </td>
            </tr>
            <tr v-if="!this.$store.getters.SPQueued.length">
                <td colspan="90">Keine offenen &Uuml;bertragungen</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>

export default ({
    methods: {
        SendNow(a) {
            this.$store.dispatch("SetScreeningPortalDelayToZero", {
                barcode: a.barcode,
            })            
        },
        CancelTransmit(a) {
            this.$store.dispatch("CancelScreeningPortalTransmit", {
                barcode: a.barcode,
            })
        }
    }
})
</script>
